import PdfDocumentScreen from 'features/urlDocumentScreens/PdfDocumentScreen/PdfDocumentScreen';
import React from 'react';

const PdfDocumentPage = () => {
  return <PdfDocumentScreen />;
};

export default PdfDocumentPage;
